/*eslint-disable */
import { Field as Fieldmik, Form as Formiker, withFormik } from "formik";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Container, Dropdown, Form as FormUi, Input, Button , Icon} from "semantic-ui-react";
import * as yup from "yup";
import {
  errorAlertDispatcher, successAlertDispatcher
} from "../../redux/actions/alertAction";
import { customerNo, DATE_ddMMYYYY, FEATURES } from "../../utils/constant";
import { AllRegex } from "../../utils/validation";
import {
  INVALID_FIELDS, REQUIRED_FIELDS
} from "../../utils/validationConstant";
import CreateAxios from "../axiosComponent/create";
import ReadAxios from "../axiosComponent/read";
import UpdateAxios from "../axiosComponent/update";
import { DateData } from "../dynamicComponent/datepick";
import { MyTextArea } from "../dynamicComponent/myInputs";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import MyPincode from "../apiInputs/myPincode";
import FormikAddPincode from "./addPincodeModal";

const InsertDrivers = ({
  values,
  setFieldValue,
  t,
  touched,
  errors,
  handleSubmit,
  editData,
  ...props
}) => {
  const [networkCard, setnetworkCard] = useState([]);
  const [Vendors, setVendors] = useState([]);
  const [openPincodeModal, setOpenPincodeModal] = useState(false)
  const [reload, setReload] = useState(false)

  useEffect(() => {
    getnetworkCardList();
    getAllVendors();
  }, []);

  
  const handleOpenPincodeModal = ()=>{
    setOpenPincodeModal(true)
  }
  const handleClosePincodeModal = ()=>{
    setOpenPincodeModal(false)
  }
  const UpdatePincodeData = ()=>{
    setReload(!reload)
  }

  const [driverStatus, setDriverStatus] = useState(false)

  const getnetworkCardList = async () => {
    let dataArray = await ReadAxios({ url: "networkProviderMaster" });
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    dataArray = dataArray.map((item, index) => {
      return {
        key: item.networkProviderCode,
        text: item.networkProviderName,
        value: item.networkProviderMasterId,
        raw: { ...item, index },
      };
    });
    setnetworkCard(dataArray);
  };

  

  const getAllVendors = () => {
    ReadAxios({ url: `transporterMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVendors([])
          : setVendorsState(res.data.resultSet);
      })
      .catch((err) => setVendors([]));
  };

  const setVendorsState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.transporterName,
        key: item.transporterCode,
        value: item.transporterMasterId,
      };
    });
    setVendors(result);
  };

  const getVendorData = (data) => {
    setFieldValue("vendorId", data.value);
    ReadAxios({ url: `transporterMaster/${data.value}` })
      .then((res) => {
        if (res.status == 200) {
          let vdata = res.data.resultSet;
          setFieldValue("vendorData", vdata);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return networkCard ? (
    <React.Fragment>
      <Formiker>
        <div className="container-fluid animated slideInDown pad w3-white">
          <div className="m-3 pl-3">
            <div className="ui form">
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.driver_name.title") || "Driver Name"} <span className="red">*</span>
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={touched.driverName && errors.driverName ? true : false}
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="driverName"
                    placeholder={
                      t("create.driver_name.placeholder") || "Driver Name"
                    }
                  />
                  {touched.driverName && errors.driverName ? (
                    <div className="error-msg">
                      {errors.driverName}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.mobile_number.title") || "Mobile No."}<span className="red">*</span>
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={
                    touched.driverContact && errors.driverContact ? true : false
                  }
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="driverContact"
                    placeholder={
                      t("create.mobile_number.placeholder") || "Mobile No."
                    }
                  />
                  {touched.driverContact && errors.driverContact ? (
                    <div className="error-msg">
                      {errors.driverContact}
                    </div>
                  ) : null}
                </FormUi.Field>

              </FormUi.Group>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.license_number.title") || "License Number"} {" "} {FEATURES.driverMaster_licNo_required && <span className="red">*</span>}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={touched.driverLic && errors.driverLic ? true : false}
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="driverLic"
                    placeholder={
                      t("create.license_number.placeholder") || "License No."
                    }
                  />
                  {touched.driverLic && errors.driverLic ? (
                    <div className="error-msg">
                      {errors.driverLic}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.sim_card_provider.title") || "Sim Card Provider"}<span className="red">*</span>
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={
                    touched.networkProviderId && errors.networkProviderId
                      ? true
                      : false
                  }
                >
                  {(!editData.serviceProviderId ||
                    values.networkProviderId) && (
                      <Dropdown
                        style={{ width: "100%" }}
                        search
                        selection
                        placeholder={
                          t("create.sim_card_provider.placeholder") || "Sim Card"
                        }
                        onChange={(name, data) =>
                          setFieldValue("networkProviderId", data.value)
                        }
                        name="networkProviderId"
                        options={networkCard}
                        defaultValue={values.networkProviderId}
                      />
                    )}
                  {touched.networkProviderId && errors.networkProviderId ? (
                    <div className="error-msg">
                      {errors.networkProviderId}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {FEATURES.usePartnerInsteadOfVendor ? (
                      <> {t("create.partner.title") || "Partner"}</>
                    ) : (
                      <>{t("create.vendor.title") || "Vendor"}</>
                    )}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Dropdown
                    name="vendorId"
                    clearable
                    search
                    style={{ width: "100%" }}
                    selection
                    placeholder={
                      t("create.vendor.placeholder") || "Select Vendor"
                    }
                    onChange={(name, data) => getVendorData(data)}
                    options={Vendors}
                    value={values.vendorId}
                  />
                  {touched.vendorId && errors.vendorId ? (
                    <div className="error-msg">
                      {errors.vendorId}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>

               
                
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("create.pan_number.title") || "Pan Number"} {FEATURES.driverMaster_panNo_required ? <span className="red">*</span> : null}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field width={4} className="display-grid-center-imp">
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="panNo"
                        placeholder={
                          t("create.pan_number.placeholder") || "Pan Number"
                        }
                      />
                      {touched.panNo && errors.panNo ? (
                        <div className="error-msg">
                          {errors.panNo}
                        </div>
                      ) : null}
                    </FormUi.Field>
                 
              </FormUi.Group>
              {FEATURES.driverMaster_show_driverBankDetails ? (
                  <>
              <FormUi.Group inline>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("create.driver_bank_account_number.title") ||
                          "Driver Bank Ac Number"}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      className="display-grid-center-imp"
                      error={
                        touched.bankAccountNo &&
                          errors.bankAccountNo
                          ? true
                          : false
                      }
                    >
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="bankAccountNo"
                        placeholder={
                          t("create.driver_bank_account_number.placeholder") ||
                          "Driver Bank Ac Number"
                        }
                      />
                      {touched.bankAccountNo &&
                        errors.bankAccountNo ? (
                        <div className="error-msg">
                          {errors.bankAccountNo}
                        </div>
                      ) : null}
                    </FormUi.Field>
                    <FormUi.Field width={2}></FormUi.Field>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("create.driver_bank_ifsc_code.title") ||
                          "Driver Bank IFSC Code"}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      className="display-grid-center-imp"
                      error={
                        touched.ifscCode &&
                          errors.ifscCode
                          ? true
                          : false
                      }
                    >
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="ifscCode"
                        placeholder={
                          t("create.driver_bank_ifsc_code.placeholder") ||
                          "Driver Bank IFSC Code"
                        }
                      />
                      {touched.ifscCode &&
                        errors.ifscCode ? (
                        <div className="error-msg">
                          {errors.ifscCode}
                        </div>
                      ) : null}
                    </FormUi.Field>
                    </FormUi.Group>

                  </>
                ) : null}

              <FormUi.Group inline>
                
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("create.aadhar_number.title") || "Aadhar Number"} {FEATURES.driverMaster_aadharNo_required ? <span className="red">*</span> : null}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      className="display-grid-center-imp"
                      error={
                        touched.aadharNo && errors.aadharNo ? true : false
                      }
                    >
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="aadharNo"
                        style={{ width: "100%" }}
                        placeholder={
                          t("create.aadhar_number.placeholder") || "Aadhar Number"
                        }
                      />
                      {touched.aadharNo && errors.aadharNo ? (
                        <div className="error-msg">
                          {errors.aadharNo}
                        </div>
                      ) : null}
                    </FormUi.Field>
                  
                <FormUi.Field width={2}></FormUi.Field>

                
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("create.driving_licence_expiry_date.title") ||
                          "Driving Licence Expiry Date"}{" "}{FEATURES.driverMaster_dlExpiry_required ? <span className="red">*</span> : null}
                      </label>
                    </FormUi.Field>

                    <FormUi.Field
                      width={4}
                      className="display-grid-center-imp"
                      error={
                        touched.dateOfJoin && errors.dateOfJoin
                          ? true
                          : false
                      }
                    >
                      <DateData
                        name="dlExiryDate"
                        tname="dlExiryDate"
                        autoComplete="off"
                        popperClassName="dateTime"
                        dateFormat={DATE_ddMMYYYY}
                        timeIntervals={5}
                        customInput={
                          <Input
                            icon="time"
                            className="poupDate"
                            iconPosition="left"
                          />
                        }
                      />
                      {touched.dlExiryDate && errors.dlExiryDate ? (
                        <div className="error-msg">
                          {errors.dlExiryDate}
                        </div>
                      ) : null}
                    </FormUi.Field>
                 
              </FormUi.Group>
              <FormUi.Group inline>
                { FEATURES.driverMaster_show_residentialAddress ? (
                  <>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("create.residential_address.title") ||
                          "Residential Address"}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      error={
                        touched.residentAddress && errors.residentAddress
                          ? true
                          : false
                      }
                    >
                      <Fieldmik
                        component={MyTextArea}
                        className="ui input"
                        name="residentAddress"
                        placeholder={
                          t("create.residential_address.placeholder") ||
                          "Residential Address"
                        }
                      />
                      {touched.residentAddress && errors.residentAddress ? (
                        <div className="error-msg">
                          {errors.residentAddress}
                        </div>
                      ) : null}
                    </FormUi.Field>
                  </>) : null}
                <FormUi.Field width={2}></FormUi.Field>
                { FEATURES.driverMaster_show_permanentAddress ? (
                  <>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("create.permanent_address.title") || "Permanent Address"}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      error={
                        touched.permanentAddress && errors.permanentAddress
                          ? true
                          : false
                      }
                    >
                      <Fieldmik
                        component={MyTextArea}
                        className="ui input"
                        name="permanentAddress"
                        placeholder={
                          t("create.permanent_address.placeholder") ||
                          "Permanent Address"
                        }
                      />
                      {touched.permanentAddress && errors.permanentAddress ? (
                        <div className="error-msg">
                          {errors.permanentAddress}
                        </div>
                      ) : null}
                    </FormUi.Field>
                  </>) : null}
                <FormUi.Field width={2}></FormUi.Field>
              </FormUi.Group>
                {FEATURES.driverMaster_show_alternateNameAndMobileNo ? (
                  <>
              <FormUi.Group inline>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("create.alternate_name.title") || "Alternate Name"} {FEATURES.driverMaster_alternateName_required ? <span className="red">*</span> : null}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      className="display-grid-center-imp"
                      error={
                        touched.alternateName && errors.alternateName
                          ? true
                          : false
                      }
                    >
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="alternateName"
                        placeholder={
                          t("create.alternate_name.placeholder") || "Alternate Name"
                        }
                      />
                      {touched.alternateName && errors.alternateName ? (
                        <div className="error-msg">
                          {errors.alternateName}
                        </div>
                      ) : null}
                    </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("create.alternate_mobile_number.title") || "Alternate Mobile Number"}{FEATURES.driverMaster_alternateMob_required ? <span className="red">*</span> : null}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      className="display-grid-center-imp"
                      error={touched.alternateMobileNo && errors.alternateMobileNo ? true : false}                    >
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="alternateMobileNo"
                        placeholder={t("create.alternate_mobile_number.placeholder") || "Alternate Mobile Number"}
                      />
                      {touched.alternateMobileNo &&
                        errors.alternateMobileNo ? (
                        <div className="error-msg">
                          {errors.alternateMobileNo}
                        </div>
                      ) : null}
                    </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
              </FormUi.Group>
                  </>) : null}
                { FEATURES.driverMaster_show_guarantorNameAndMobileNo ? (
                  <>
              <FormUi.Group inline>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("create.guarantor_name.title") || "Guarantor Name"}{ FEATURES.driverMaster_guarantorName_required ? <span className="red">*</span> : null}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      className="display-grid-center-imp"
                      error={touched.guarantorName && errors.guarantorName ? true : false}                    >
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="guarantorName"
                        placeholder={
                          t("create.guarantor_name.placeholder") || "Guarantor Name"
                        }
                      />
                      {touched.guarantorName && errors.guarantorName ? (
                        <div className="error-msg">
                          {errors.guarantorName}
                        </div>
                      ) : null}
                    </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>         
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("create.guarantor_mobile_number.title") || "Guarantor Mobile Number"}{ FEATURES.driverMaster_guarantorMob_required ? <span className="red">*</span> : null}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      className="display-grid-center-imp"
                      error={touched.guarantorMobileNo && errors.guarantorMobileNo ? true : false}>
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="guarantorMobileNo"
                        placeholder={
                          t("create.guarantor_mobile_number.placeholder") ||
                          "Guarantor Mobile Number"
                        }
                      />
                      {touched.guarantorMobileNo &&
                        errors.guarantorMobileNo ? (
                        <div className="error-msg">
                          {errors.guarantorMobileNo}
                        </div>
                      ) : null}
                    </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
              </FormUi.Group>
                  </>) : null}

                {FEATURES.driverMaster_show_dateOfJoining ? (
                  <>
              <FormUi.Group inline>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("create.date_of_joining.title") || "Date of Joining"}{ FEATURES.driverMaster_dateOfJoining_required ? <span className="red">*</span> : null}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      className="display-grid-center-imp"
                      error={
                        touched.dateOfJoin && errors.dateOfJoin
                          ? true
                          : false
                      }
                    >
                      <DateData
                        name="dateOfJoin"
                        tname="dateOfJoin"
                        autoComplete="off"
                        popperClassName="dateTime"
                        dateFormat={DATE_ddMMYYYY}
                        timeIntervals={5}
                        customInput={
                          <Input
                            icon="time"
                            className="poupDate"
                            iconPosition="left"
                          />
                        }
                      />
                      {touched.dateOfJoin && errors.dateOfJoin ? (
                        <div className="error-msg">
                          {errors.dateOfJoin}
                        </div>
                      ) : null}
                    </FormUi.Field>
              </FormUi.Group>
                  </>) : null}
              <FormUi.Group>
              { FEATURES.driverMaster_show_driverLeftCheckbox ? (
                <>
                    <FormUi.Field width={2}>
                      <label style={{ border: "1px solid #bbb", backgroundColor: "#eee", borderRadius: "5px", padding: "5px" }}>
                        <input type="checkbox" name="driverLeft"
                          onChange={(e) => { if (values.driverLeft == 1) { setFieldValue("driverLeft", 0) } else { setFieldValue("driverLeft", 1) } }}
                          checked={values.driverLeft == 1 ? true : false} style={{ verticalAlign: "middle", marginRight: "5px" }} />
                       {t("create.driver_left_company.title")||"Driver Left Company"}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field width={6}/>
                </>) : null}

                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("create.pincodes.title")||"Pincodes"}
                      </label>
                    </FormUi.Field>

                    <FormUi.Field width={4} >
                  <FormUi.Group inline>
                    <Fieldmik
                    component={MyPincode}
                    name="pincodes"
                    reload={reload}
                    UpdatePincodeData={UpdatePincodeData}
                    multiSelect={true}
                    multiple
                    value={values.pincodes}
                    placeholder={
                      t("create.pincodes.placeholder")||"Select Pincode"
                    }
                  />
                  <FormikAddPincode open={openPincodeModal} handleOpen={handleOpenPincodeModal} handleClose={handleClosePincodeModal} updatePincodeData={UpdatePincodeData} />
                  </FormUi.Group>
                    </FormUi.Field>
                  </FormUi.Group>
            </div>
          </div>
        </div>
        <Container className="p-3" textAlign="center">
          <button
            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
            type="submit"
          >
            {t("create.action_button.submit") || "Submit"}
          </button>
        </Container>
      </Formiker>
    </React.Fragment>
  ) : (
    <LoadingPlaceholder />
  );
};

const FormikDrivers = withFormik({
  enableReinitialize: true,
  validationSchema: yup.object({
    driverName: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).matches(AllRegex.Name, INVALID_FIELDS.INVALID_NAME),
    driverContact: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).matches(AllRegex.MobileNumber, INVALID_FIELDS.INVALID_MOBILE_NO),
    driverLic: FEATURES.driverMaster_licNo_required ?yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).matches(AllRegex.LicenseNumber, INVALID_FIELDS.INVALID_LICENCE_NO) : yup.string().optional().matches(AllRegex.LicenseNumber, INVALID_FIELDS.INVALID_LICENCE_NO),
    networkProviderId: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED),
    vendorId: yup.string().optional(),
    panNo: FEATURES.driverMaster_panNo_required ? yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).matches(AllRegex.PANIN, INVALID_FIELDS.INVALID_PAN_NUMBER) :
      yup.string().optional().matches(AllRegex.PANIN, INVALID_FIELDS.INVALID_PAN_NUMBER),
    aadharNo: FEATURES.driverMaster_aadharNo_required ? yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).matches(AllRegex.AadharNumber, INVALID_FIELDS.INVALID_ADHAR_NUMBER) :
      yup.string().optional().matches(AllRegex.AadharNumber, INVALID_FIELDS.INVALID_ADHAR_NUMBER),
    dlExiryDate: FEATURES.driverMaster_dlExpiry_required ? yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).nullable() :
      yup.string().optional().nullable(),
    residentAddress: yup.string().optional().matches(AllRegex.Address, INVALID_FIELDS.INVALID_ADDRESS),
    permanentAddress: yup.string().optional().matches(AllRegex.Address, INVALID_FIELDS.INVALID_ADDRESS),
    alternateName: FEATURES.driverMaster_alternateName_required ? yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).matches(AllRegex.Name, INVALID_FIELDS.INVALID_NAME) :
      yup.string().optional().matches(AllRegex.Name, INVALID_FIELDS.INVALID_NAME),
    alternateMobileNo: FEATURES.driverMaster_alternateMob_required ? yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).matches(AllRegex.MobileNumber, INVALID_FIELDS.INVALID_MOBILE_NO) :
      yup.string().optional().matches(AllRegex.MobileNumber, INVALID_FIELDS.INVALID_MOBILE_NO),
    guarantorName: FEATURES.driverMaster_guarantorName_required ? yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).matches(AllRegex.Name, INVALID_FIELDS.INVALID_NAME) :
      yup.string().optional().matches(AllRegex.Name, INVALID_FIELDS.INVALID_NAME),
    guarantorMobileNo: FEATURES.driverMaster_guarantorMob_required ? yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).matches(AllRegex.MobileNumber, INVALID_FIELDS.INVALID_MOBILE_NO) :
      yup.string().optional().matches(AllRegex.MobileNumber, INVALID_FIELDS.INVALID_MOBILE_NO),
    dateOfJoin: FEATURES.driverMaster_dateOfJoining_required ? yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).nullable() :
      yup.string().optional().nullable(),
    bankAccountNo: yup.string().optional().matches(AllRegex.BankAccNumber, INVALID_FIELDS.INVALID_BANK_ACCOUNT_NO),
    ifscCode: yup.string().optional().matches(AllRegex.BankIFSCcode, INVALID_FIELDS.INVALID_IFSC_CODE),
  }),
  mapPropsToValues: (props) => {
    return {
      driverName: props?.editData?.driverName || "",
      driverContact: props?.editData?.driverContact || "",
      driverLic: props?.editData?.driverLicense || "",
      networkProviderId: +props?.editData?.serviceProviderId || "",
      vendorId: props?.editData?.vendorId || "",
      panNo: props?.editData?.panNo || "",
      aadharNo: props?.editData?.aadharNo || "",
      dlExiryDate: props?.editData?.dlExiryDate ? new Date(props.editData.dlExiryDate) : "",
      residentAddress: props?.editData?.residentAddress || "",
      permanentAddress: props?.editData?.permanentAddress || "",
      alternateName: props?.editData?.alternateName || "",
      alternateMobileNo: props?.editData?.alternateMobileNo || "",
      guarantorName: props?.editData?.guarantorName || "",
      guarantorMobileNo: props?.editData?.guarantorMobileNo || "",
      dateOfJoin: props?.editData?.dateOfJoin || "",
      bankAccountNo: props?.editData?.bankAccountNo || "",
      ifscCode: props?.editData?.ifscCode || "",
      driverLeft: props?.editData?.driverLeft || 0,
      pincodes: props?.editData?.pincodes || []
    };
  },
  async handleSubmit(values, { props }) {
    if (props?.editData?.driverMasterId) {
      await UpdateAxios({
        url: "driverMaster",
        payload: { ...values },
        uniqueId: props?.editData?.driverMasterId,
      })
        .then((res) => {
          if (res.data.status == 200) {
            let alert = {
              type: "success",
              messageHeader: "Success",
              messageBody: res.data.message,
            };
            props.successAlertDispatcher(alert);
            props.onFormSubmit();
          } else {
            let alert = {
              type: "success",
              messageHeader: "Error",
              messageBody: res.data.message,
            };
            props.errorAlertDispatcher(alert);
          }
        })
        .catch((err) => {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.data.message,
          };
          console.log(err);
          props.errorAlertDispatcher(alert);
        });
    } else {
      await CreateAxios({
        url: "driverMaster",
        payload: { ...values },
      })
        .then((res) => {
          if (res.data.status == 200) {
            let alert = {
              type: "success",
              messageHeader: "Success",
              messageBody: res.data.message,
            };
            props.successAlertDispatcher(alert);
            props.onFormSubmit();
          } else {
            let alert = {
              type: "error",
              messageHeader: "Error",
              messageBody: res.data.message,
            };
            props.errorAlertDispatcher(alert);
          }
        })
        .catch((err) => {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.response.data.message,
          };
          props.errorAlertDispatcher(alert);
        });
    }
  },
})(InsertDrivers);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("driver")(FormikDrivers)
);
